import * as Sentry from '@sentry/react'
import axios from 'axios'

Sentry.init({
  dsn: 'https://9f6ed80362e94d5fb339ac633694fb76@o507863.ingest.us.sentry.io/5599541',
  environment: process.env.REACT_APP_ENV === 'production' ? 'prod' : 'sandbox',
  debug: process.env.REACT_APP_ENV !== 'production',
  maxBreadcrumbs: 50,
})

const isFilteredAxiosError = error => {
  const status = error?.response?.status
  const url = error?.config?.url

  if (status === 401) return true
  if (status === 404 && url?.includes('secure/user/pic')) return true
  if (url?.includes('/secure/kit')) return true

  const message = error?.message
  if (message?.includes('ref.current')) return true
  if (message?.includes('Network Error')) return true

  return false
}

/**
 * Attach the Sentry response error interceptor to an axios client. Exported so
 * that the dedicated `ApiService` client (created via `axios.create()`) can
 * register the same Sentry capture/filter logic as the global axios client.
 *
 * Without this, errors from the ApiService client would not be captured because
 * `axios.create()` instances do not inherit interceptors from the default
 * instance.
 */
export const attachSentryResponseInterceptor = client => {
  client.interceptors.response.use(
    response => response,
    error => {
      if (!isFilteredAxiosError(error)) {
        Sentry.captureException(error)
      }
      return Promise.reject(error)
    },
  )
}

attachSentryResponseInterceptor(axios)
